import { Card } from "../../models/card";
import { questFlags, cards } from "../../state";
import { PurpleGem } from "../resources/purpleGem";
import { forceUpdate, dropCard } from "../..";
export class PurpleGemMaker extends Card {
}
PurpleGemMaker.displayName = "Purple Gem";
PurpleGemMaker.artUrl = "./assets/cards/purplegem.jpg";
PurpleGemMaker.effect = {
    callback: (card) => {
        questFlags.hasSeenPurple = true;
        let newPos = { x: card.position.x - 8, y: card.position.y - 180 };
        const newCard = new PurpleGem(newPos);
        cards.push(newCard);
        forceUpdate();
        dropCard(newCard);
    },
    description: "Get a Purple Gem",
    needsFeedback: false,
};
